import React, { useState } from 'react';
import { Form, Modal } from 'antd';
import { get } from 'lodash';
import { Loading } from '@components/common';
import { CURRENT_PRODUCT_MODE } from '@utils/constants';
import { GeneralForm, AdvancedForm, Buttons } from './components';
import { FormContext } from './context';
import { useCreateAlert, useSave, useNext, usePrev, useUpdateAlert } from './hooks';
interface IProps {
  visible?: boolean;
  alert?: any;
  onCancel: () => void;
}

const defaultAdvancedSettings = {
  attachment: false,
  lifespan: null,
  cooldown: 60,
  priority: 3,
  type: CURRENT_PRODUCT_MODE === 'EI' ? 0 : 2,
};

const AlertForm = ({ visible = false, alert: inputAlert = {}, onCancel }: IProps) => {
  const [current, setCurrent] = useState(0);
  const initial = { ...defaultAdvancedSettings, ...inputAlert };
  const [alert, setAlert] = useState(initial);
  const [saving, setSaving] = useState(false);

  const createAlert = useCreateAlert(setSaving);
  const updateAlert = useUpdateAlert(setSaving, initial);

  const [generalForm] = Form.useForm();
  const [advancedForm] = Form.useForm();

  const onSave = useSave({
    alert,
    generalForm,
    advancedForm,
    createAlert,
    updateAlert,
    setAlert,
    setSaving,
  });

  const onNext = useNext({
    generalForm,
    setAlert,
    alert,
  });

  const onPrev = usePrev({
    advancedForm,
    setAlert,
    alert,
  });

  return (
    <Modal
      width={600}
      open={visible}
      destroyOnHidden
      footer={
        <Buttons
          current={current}
          setCurrent={setCurrent}
          saving={saving}
          onSave={onSave}
          onNext={onNext}
          onPrev={onPrev}
        />
      }
      onCancel={onCancel}
      title={get(alert, 'id') ? 'Edit Alert' : 'Create Alert'}
    >
      <FormContext.Provider value={{ alert }}>
        {saving && <Loading />}
        {current === 0 && <GeneralForm form={generalForm} />}
        {current === 1 && <AdvancedForm form={advancedForm} />}
      </FormContext.Provider>
    </Modal>
  );
};

export default AlertForm;
